export const skills = [
  { group: "Languages", items: ["Python", "Go", "TypeScript", "JavaScript", "SQL", "C++", "C", "Java"] },
  { group: "Backend & infra", items: ["REST APIs", "PostgreSQL", "MySQL", "Kafka", "Prometheus", "Docker", "Kubernetes", "Jenkins"] },
  { group: "AI / ML", items: ["RAG pipelines", "Vector databases", "LLM observability"] },
  { group: "Coursework", items: ["C++", "Distributed Systems", "Operating Systems", "Networks", "Algorithms"] },
];

export const awards = [
  "Top 4 Innovations, Canada-Wide Science Fair, for an EEG fatigue-detection headband",
  "Top 100 youth innovator, INSPO North Continental Research Fair",
  "VEX Robotics World Championships competitor; top 4 in Canada for skills",
];
